import { render, staticRenderFns } from "./BillingDocumentsSummary.vue?vue&type=template&id=473601f0&scoped=true"
import script from "./BillingDocumentsSummary.vue?vue&type=script&lang=js"
export * from "./BillingDocumentsSummary.vue?vue&type=script&lang=js"
import style0 from "./BillingDocumentsSummary.vue?vue&type=style&index=0&id=473601f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473601f0",
  null
  
)

export default component.exports